export default function toArray(value){return value==null?[]:[].concat(value);}